import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureCardGrid from "../components/FeatureCardGrid";
import { Globe, CalendarDays, Receipt, Banknote, ListChecks, Building2 } from "lucide-react";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { FEATURE_SOFTWARE_LD } from "../data/featurePages";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/fonctionnalites/prop-firm-manager";

export default function FeaturePropFirmManagerPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.features.propFirmManager;
  return (
    <MarketingPageLayout>
      <SeoHelmet path={PATH} title={m.title} description={m.description} jsonLd={[FEATURE_SOFTWARE_LD]} />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureCardGrid
        bullets={c.bullets}
        image="/images/features/prop-firm-manager.png"
        imageAlt={c.h1}
        icons={[Globe, CalendarDays, Receipt, Banknote, ListChecks, Building2]}
      />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/fonctionnalites/dashboard-trading", label: t.marketing.nav.megaFeatures[5].label },
          { to: "/fonctionnalites/analytics-trading", label: t.marketing.nav.megaFeatures[2].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
